
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/lab-date-pickers-to-mui-x",
      function () {
        return require("private-next-pages/blog/lab-date-pickers-to-mui-x.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/lab-date-pickers-to-mui-x"])
      });
    }
  